import { render, staticRenderFns } from "./Laptop.vue?vue&type=template&id=77220500&scoped=true&"
import script from "./Laptop.vue?vue&type=script&lang=js&"
export * from "./Laptop.vue?vue&type=script&lang=js&"
import style0 from "./Laptop.vue?vue&type=style&index=0&id=77220500&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77220500",
  null
  
)

export default component.exports